<template>
  <div class="photo-thumb">
    <div
      class="video-thumb__content d-flex justify-space-between align-center px-md-3 px-1 py-2"
    >
      <v-row no-gutters>
        <v-col cols="12" md="8" v-if="!isHide">
          <div class="d-flex avatarBox align-center">
            <AvatarComponent
              size="38"
              :url="value.channelLogo"
            />
            <div class="boxedContent mx-3">
              <h5 class="video-thumb__title">
                <strong>
                  <a
                    class="white--text" style="text-decoration: none"
                    target="_blank"
                    :href="'https://www.youtube.com/channel/' + value.channelId"
                  >
                    {{ value.channelName }}
                  </a>
                </strong>
              </h5>

              <p class="video-thumb__stat white--text caption mb-0">
                <span>{{
                  `${nFormatter(value.channelSubscriber) || 0} ${$gettext(
                    "subscribers"
                  )}`
                }}</span>
              </p>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="4" class="justify-end d-flex align-center" v-if="!isHide">
          <div>
            <p class="video-thumb__stat white--text caption text-center mb-0">
              <span>{{
                `${formatterViews(value.view) || 0} ${$gettext("views")}`
              }}</span>
            </p>
          </div>
        </v-col>
      </v-row>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    isHide: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openPhotoPage() {
      this.$emit("openDialogDetail", this.vlog || null);
    },
    gotoChannel() {
      window.open(
        `https://www.youtube.com/channel/${this.value.channelId}`,
        "_blank"
      );
    },
    formatterViews(num) {
      if (num) {
        return parseInt(num).toLocaleString();
      }
      return 0;
    },
    nFormatter(num) {
      num = parseInt(num);
      if (num >= 1000000000) {
        return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
      }
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
      }
      if (num >= 1000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
      }
      return num;
    }
  }
};
</script>
